import DB from "@/common/utils/db";

/**
 * @description 获取雇主列表
 */
export function getList(query) {
  return DB({
    url: "v1/enterpris/newly",
    method: "get",
    params: query
  });
}
/**
 * @description 获取雇主详情
 */
export function getDetail(query) {
  return DB({
    url: "v1/enterpris/"+query.id,
    method: "get"
  });
}
/**
 * @description 关注公司
 */
export function follow(query) {
  return DB({
    url: 'v1/enterpris/'+query.enterpriseId+'/follow',
    method: "post"
  });
}
/**
 * @description 取消关注公司
 */
export function unFollow(query) {
  return DB({
    url: 'v1/enterpris/'+query.enterpriseId+'/unfollow',
    method: "post"
  });
}